import { Status } from "./Status";
import { Telemetry } from "./Telemetry";


export class BaseResponse {
    status: Status;
    telemetry: Telemetry;
    actions: number[]
}